import React from 'react';
import { motion } from 'framer-motion';
import { Reveal, Stagger, staggerItem } from './MotionPrimitives';

const principles = [
  {
    title: 'One truth for stock',
    body: 'App, counter, and warehouse share the same shelf numbers - so you stop overselling and guessing.',
    icon: '◆',
  },
  {
    title: 'Your brand, not ours',
    body: 'Customers shop in an app that looks like your shop - colours, banners, name → not a generic marketplace.',
    icon: '★',
  },
  {
    title: 'Branches under control',
    body: 'Head office sees everything. Store staff only see their outlet. Stock moves with approval, not WhatsApp chaos.',
    icon: '◎',
  },
  {
    title: 'Deliver & recover cleanly',
    body: 'Own riders or courier, OTP proof, returns desk, and unhappy-review tickets - nothing forgotten in chats.',
    icon: '▲',
  },
];

export default function Principles() {
  return (
    <section className="section-pad bg-black">
      <div className="mx-auto max-w-7xl">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="pill-light">Our Core</span>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            How we <span className="grad-text">build Zuntly</span>
          </h2>
          <p className="mt-4 text-mute">
            Simple rules we stick to for shop owners and distributors.
          </p>
        </Reveal>

        <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <motion.article key={p.title} variants={staggerItem} className="il-card">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-accent/30 bg-accent/10 text-accent">
                {p.icon}
              </div>
              <h3 className="mt-5 text-lg font-bold text-white">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-mute">{p.body}</p>
            </motion.article>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
